import React, { ReactNode } from 'react';
import { SectionTitleBlock } from '@lmt/unicorn-shared/app/components/common/ui-kit/configuration/SectionTitleBlock';

import styles from '@lmt/unicorn-shared/src/app/components/common/ui-kit/configuration/SettingsBlock.module.scss';

interface Props {
  blockId: string;
  blockTitle: string;
}

export const SettingsBlock: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <div className={styles.container} id={`section_${props.blockId}`}>
      <div
        data-section-item-id={props.blockId}
        className={styles.blockScrollMarker}
      />
      <SectionTitleBlock title={props.blockTitle} />
      <div className={styles.settingsContainer}>{props.children}</div>
    </div>
  );
};
